import {Component, HostListener,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {AutofocusDirective} from '../../../../../directives/autofocus/autofocus.directive';
import {AsyncPipe} from '@angular/common';
import {TranslatePipe} from '@spartacus/core';

@Component({
  selector: 'dcp-write-review-modal',
  templateUrl: './write-review-dialog.component.html',
  styleUrls: ['./write-review-dialog.component.scss'],
  imports: [AutofocusDirective, AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class WriteReviewDialogComponent {
  constructor(public launchDialogService: LaunchDialogService) {}

  @HostListener('document:keydown.escape')
  @HostListener('click')
  handleClickOrEsc(): void {
    this.launchDialogService.closeDialog('Cross click');
  }

  public get link$(): Observable<string> {
    return this.launchDialogService.data$.pipe(map((data) => data.link));
  }

  public get headlineText$(): Observable<string> {
    return this.launchDialogService.data$.pipe(map((data) => data.headlineText));
  }
}
